export const MenuItemArrowSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="18" height="18">
  <style>
    .disabled{opacity:0.35}
    .active path{fill:#333}
    path,.disabled path{fill:#666}
  </style>
  <path d="M7.3,13.2l4.6-3.5c0.1-0.1,0.1-0.2,0-0.3L7.3,5.8C7.1,5.7,7,5.8,7,6v7C7,13.2,7.1,13.3,7.3,13.2z"/>
</svg>`;
